import { Typography } from '@mui/material';
import { Overlay } from './Styles';
import Spinner from 'components/Spinner';
import intl from 'react-intl-universal';

const AILoader = () => {
  return (
    <Overlay>
      <Spinner size={70} />
      <Typography variant="h6" style={{ marginTop: '10px' }}>
        {intl.get('issue_details_ai_loader_text')}
      </Typography>
    </Overlay>
  );
};

export default AILoader;
